module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('a', {
    attrs: {
      "id": "int"
    }
  }), _vm._v("INTRODUCTION")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_vm._v("What does your life hold in store for you? Each of us has a unique fortune, determined by many factors. And learning more about your own fortune will give you the tools to steer your life in a positive and successful direction.")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_vm._v("The first three chapters of this book discuss fixed characteristics—your birthday, your zodiac sign, and your name—to help you understand the meanings behind them and, as a result, know yourself better. The fourth chapter focuses on dreams, which can both reflect your subconscious mind and forecast your future. The subject of the fifth chapter is color: how the colors you choose to surround yourself with can serve as a window into your personality, and how you can also harness the power of color to change your fortunes for the better. The final chapter delves into relationships and examines portents of new love and friendship, and also offers ways to usher lasting love and friendship into your life.")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_vm._v("Are you ready to ascertain your fate and learn how to actively invite good fortune into your life? Then read on.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7950da10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05-introduction.vue
// module id = 69
// module chunks = 0